import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import CV from "./components/CV/CV";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Stack from "./components/Stack/Stack";
import Footer from "./components/Footer";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Contacts from "./components/Contacts/Contacts";

// Disable logs
(function () {
  let method;
  let noop = function noop() { };
  let methods = [
    'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
    'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
    'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
    'timeStamp', 'trace', 'warn'
  ];
  let length = methods.length;
  let console = (window.console = window.console || {});

  while (length--) {
    method = methods[length];
    console[method] = noop;
  }
}());

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route key={"ap01"} path="/" element={<Home />} />
          <Route key={"ap02"} path="/projects" element={<Projects />} />
          <Route key={"ap03"} path="/cv" element={<CV key={'ap030'}/>} />
          <Route key={"ap04"} path="/about" element={<About />} />
          <Route key={"ap06"} path="/stack" element={<Stack />} />
          <Route key={"ap07"} path="/contacts" element={<Contacts />} />
          <Route key={"ap09"} path="https://site.surkoff.com/blog" />
          <Route key={"ap08"} path="*" element={<Navigate to="/"/>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
